/**
 * 路由页面列表
 */
import { IRoute } from "@/routes/index";

export const routes: IRoute[] = [
  {
    name: "Home",
    key: "home",
    path: "/home",
    ignore: false,
    breadcrumb: false,
    level: 1,
    cache: true,
  },
  {
    name: "HowToPlay",
    key: "howToPlay",
    path: "/howToPlay",
    breadcrumb: true,
    ignore: false,
    level: 1,
    cache: true,
  },
  {
    name: "PrivacyPolicy",
    key: "privacyPolicy",
    path: "/privacyPolicy",
    breadcrumb: true,
    ignore: false,
    level: 1,
    cache: true,
  },
  {
    name: "TermsOfService",
    key: "termsOfService",
    path: "/termsOfService",
    breadcrumb: true,
    ignore: false,
    level: 1,
    cache: true,
  },
  {
    name: "ResponsibleGaming",
    key: "responsibleGaming",
    path: "/responsibleGaming",
    breadcrumb: true,
    ignore: false,
    level: 1,
    cache: true,
  },
  {
    name: "Casino",
    key: "casino",
    path: "/home",
    ignore: false,
    breadcrumb: false,
    level: -1,
    children: [
      {
        name: "Hot",
        key: "hotList",
        path: "/hotList",
        breadcrumb: true,
        level: 1,
        cache: true,
      },
      {
        name: "Slot",
        key: "slotList",
        path: "/slotList",
        breadcrumb: true,
        level: 1,
        cache: true,
      },
      {
        name: "Jili",
        key: "jiliList",
        path: "/jiliList",
        breadcrumb: true,
        level: 1,
        cache: true,
      },
      {
        name: "PG",
        key: "pgList",
        path: "/pgList",
        breadcrumb: true,
        level: 1,
        cache: true,
      },
      {
        name: "PP",
        key: "ppList",
        path: "/ppList",
        breadcrumb: true,
        level: 1,
        cache: true,
      },
      {
        name: "JDB",
        key: "jdbList",
        path: "/jdbList",
        breadcrumb: true,
        level: 1,
        cache: true,
      },
      {
        name: "hacksaw",
        key: "hacksawList",
        path: "/hacksawList",
        breadcrumb: true,
        level: 1,
        cache: true,
      },
      {
        name: "Interesting",
        key: "interestingList",
        path: "/interestingList",
        breadcrumb: true,
        level: 1,
        cache: true,
      },
      {
        name: "Played",
        key: "playedList",
        path: "/playedList",
        breadcrumb: true,
        auth: true,
        level: 1,
      },
      {
        name: "Mini",
        key: "miniGameList",
        path: "/miniGameList",
        breadcrumb: true,
        level: 1,
        cache: true,
      },
      {
        name: "Bingo",
        key: "bingo",
        path: "/bingo",
        breadcrumb: true,
        level: 1,
        cache: true,
      },
      {
        name: "Table",
        key: "tableList",
        path: "/tableList",
        breadcrumb: true,
        ignore: false,
        level: 1,
        cache: true,
      },
      {
        name: "Fishing",
        key: "fishing",
        path: "/fishing",
        breadcrumb: true,
        level: 1,
        cache: true,
      },
      {
        name: "Recommend",
        key: "recommendList",
        path: "/recommendList",
        breadcrumb: true,
        level: 1,
        cache: true,
      },
      {
        name: "Favorite",
        key: "favoriteList",
        path: "/favoriteList",
        breadcrumb: true,
        auth: true,
        level: 1,
      },
      {
        name: "Privacy",
        key: "PrivacyPage",
        path: "/PrivacyPage",
        breadcrumb: false,
        ignore: true,
        level: 1,
      },
    ],
  },
  {
    name: "Bonus",
    key: "bonus",
    path: "/bonus",
    breadcrumb: false,
    ignore: true,
    auth: true,
    level: 1,
  },
  {
    name: "Sport",
    key: "sport",
    path: "/sport",
    ignore: false,
    breadcrumb: false,
    level: -1,
    children: [
      {
        name: "SportIm",
        key: "sportsIm",
        path: "/sportsIm",
        breadcrumb: false,
        auth: true,
        level: 1,
      },
      {
        name: "SportPb",
        key: "sportsPb",
        path: "/sportsPb",
        breadcrumb: false,
        auth: true,
        level: 1,
      },
    ],
  },
  {
    name: "Activity",
    key: "Activity",
    path: "/Activity",
    breadcrumb: false,
    level: 1,
  },
  {
    name: "ActivityDetail",
    key: "ActivityDetails",
    path: "/ActivityDetails/:id",
    breadcrumb: true,
    ignore: true,
    level: 1,
  },
  {
    name: "Vip",
    key: "vip",
    path: "/vip",
    breadcrumb: true,
    notPage: true,
    ignore: false,
    auth: true,
    level: 1,
  },
  {
    name: "InviteDashBoard",
    key: "InviteDashBoard",
    path: "/InviteDashBoard/:id",
    breadcrumb: false,
    ignore: true,
    level: 1,
  },
  {
    name: "NationalProxy",
    key: "NationalProxy",
    path: "/NationalProxy",
    breadcrumb: true,
    auth: true,
    level: 1,
  },
  {
    name: "Game",
    key: "game",
    path: "/game/:id",
    breadcrumb: true,
    ignore: true,
    level: 1,
  },
  {
    name: "PlatformGames",
    key: "platformList",
    path: "/platformList/:platformCode",
    breadcrumb: false,
    ignore: true,
    level: 1,
  },
  {
    name: "GlobalSettings",
    key: "GlobalSettings",
    path: "/globalSettings/:id",
    breadcrumb: true,
    ignore: true,
    auth: true,
    level: 1,
  },
  {
    name: "test",
    key: "test",
    path: "/test",
    breadcrumb: false,
    ignore: true,
    level: 1,
  },
  {
    name: "iosImage",
    key: "iosImage",
    path: "/iosImage",
    breadcrumb: false,
    ignore: true,
    level: 1,
  },
];
